import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'
const productFragment = gql`
  fragment productFragment on Product {
    _id
    code
    name
    price
    coverImage
    coverImageThumb
    summary
    inStock
    originalPrice
    discountPercentage
    orderUom {
      _id
      code
      name
      symbol
    }
  }
`

export const queries = buildGraphqlQuery('Product', productFragment)
